import React from "react";

function About() {
  return (
    <div>
      <h3>hello from About</h3>
    </div>
  );
}
export default About;